import http from "../../core/services/http.service";

export default {
  getInvoicePayments(params = null) {
    return http.get(`/api/v1/invoices/invoice-payments/`, {params});
  },
};
